import { Box, TextField } from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { HANDLE_FIELD, HandleField, handleBlocked, useHandleCheck } from "./handle-field";

export const UserCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    watch,
    formState: { errors },
  } = useForm({});
  // User 0: nobody, so the answer is whether anyone holds it. Blank asks
  // nothing, and the server then gives the account one from its name.
  const typedHandle: string = watch(HANDLE_FIELD) ?? "";
  const handleCheck = useHandleCheck(0, typedHandle, "");

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{ ...saveButtonProps, disabled: saveButtonProps.disabled || handleBlocked(handleCheck) }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("email", {
            required: "Email is required",
          })}
          error={!!errors?.email}
          helperText={errors?.email?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="email"
          label="Email"
          name="email"
        />

        <TextField
          {...register("name", {
            required: "Name is required",
          })}
          error={!!errors?.name}
          helperText={errors?.name?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />

        <HandleField
          register={register}
          check={handleCheck}
          emptyHelp="Leave blank to make one from the name, as signup does."
        />

        <TextField
          {...register("credits", {
            required: "Credits is required",
            valueAsNumber: true,
          })}
          error={!!errors?.credits}
          helperText={errors?.credits?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Credits"
          name="credits"
        />
      </Box>
    </Create>
  );
};